import { FiEye } from "react-icons/fi";
import { RfxLeadInfoBox } from "./RfxLeadInfoBox";

interface CompanyUserReadOnlyViewProps {
	rfxLeadName: string;
	rfxLeadEmail: string;
	rfxLeadPhone?: string;
}

export const CompanyUserReadOnlyView: React.FC<CompanyUserReadOnlyViewProps> = ({
	rfxLeadName,
	rfxLeadEmail,
	rfxLeadPhone,
}) => {
	return (
		<div className="space-y-4" data-testid="company-user-readonly-view">
			<div className="flex items-center gap-2 rounded-lg border border-[#0031DD]/20 bg-[#e8eeff] px-3 py-2">
				<FiEye size={14} className="shrink-0 text-[#0031DD]" aria-hidden="true" />
				<p className="text-xs text-[#0031DD]">
					You have view-only access to this evaluation. Contact the RFx Lead
					if you need to participate as a panel member.
				</p>
			</div>

			<RfxLeadInfoBox
				fullName={rfxLeadName}
				email={rfxLeadEmail}
				phoneNumber={rfxLeadPhone}
			/>
		</div>
	);
};
